import { getControlDescription } from './hoverTooltipDescMap';
import { getHoverTooltipHotkey } from './hoverTooltipHotkeyMap';
import { isCurrentCultureRightToLeft } from 'owa-localize';
import { RibbonControlId } from 'owa-ribbon-ids';

const isRTL: boolean = isCurrentCultureRightToLeft();

export function getHoverTooltip(
    controlId: RibbonControlId,
    controlName: string
): string | undefined {
    const description: string | undefined = getControlDescription(controlId);
    const hotkey: string | undefined = getHoverTooltipHotkey(controlId);

    if (hotkey) {
        return (
            (isRTL ? `(${hotkey}) ${controlName}` : `${controlName} (${hotkey})`) +
            (description ? `\n\n${description}` : '')
        );
    }

    if (description) {
        return `${controlName}\n\n${description}`;
    }

    return undefined;
}
